import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import usePeriods from '../../state/hooks/usePeriods';
import { metricNames } from '@linearb/linjs-common';
import { LBButton } from '@linearb/buzz';
import { useViewInActivity } from 'components/hooks/useViewInActivity';

const METRICS_WITH_NO_VIEW_IN_ACTIVITY = [metricNames.REVIEW_DEPTH];

const ViewInActivity = () => {
  const {
    state: { widget, metricName, selectedPoints, filters }
  } = useContext(MetricsInspectionContext);
  const { lastPeriod } = usePeriods();

  const { onClickViewInActivity } = useViewInActivity();

  return (
    METRICS_WITH_NO_VIEW_IN_ACTIVITY.includes(metricName) || (
      <LBButton
        onClick={() =>
          onClickViewInActivity({
            widget,
            metricName,
            lastPeriod,
            filters,
            selectedPoints
          })
        }
      >
        View in activity
      </LBButton>
    )
  );
};

export default ViewInActivity;
